import React from "react";
import { Row, Col, Form, Button, InputGroup } from "react-bootstrap";

const SchoolFilterBar = ({
  view, setView,         // "all" | "active" | "expiring"
  plan, setPlan,         // "all" | "free" | "basic" | "pro" | "enterprise"
  search, setSearch,     // string
  expDays, setExpDays,   // number
  onClear,
}) => {
  return (
    <div className="mb-3">
      <Row className="g-2 align-items-end">
        <Col md={3} sm={6}>
          <Form.Label className="mb-1">View</Form.Label>
          <Form.Select value={view} onChange={(e) => setView(e.target.value)}>
            <option value="all">All schools</option>
            <option value="active">Active subscriptions</option>
            <option value="expiring">Expiring soon</option>
          </Form.Select>
        </Col>

        <Col md={3} sm={6}>
          <Form.Label className="mb-1">Plan</Form.Label>
          <Form.Select value={plan} onChange={(e) => setPlan(e.target.value)}>
            <option value="all">All plans</option>
            <option value="free">Free</option>
            <option value="basic">Basic</option>
            <option value="pro">Pro</option>
            <option value="enterprise">Enterprise</option>
          </Form.Select>
        </Col>

        <Col md={3} sm={6}>
          <Form.Label className="mb-1">Search</Form.Label>
          <InputGroup>
            <InputGroup.Text><i className="bi bi-search" /></InputGroup.Text>
            <Form.Control
              placeholder="School name or ID"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </InputGroup>
        </Col>

        <Col md={2} sm={6}>
          <Form.Label className="mb-1">Expiring in</Form.Label>
          <InputGroup>
            <Form.Control
              type="number"
              min={1}
              value={expDays}
              onChange={(e) => setExpDays(Number(e.target.value || 1))}
            />
            <InputGroup.Text>days</InputGroup.Text>
          </InputGroup>
        </Col>

        <Col md={1} className="d-grid">
          <Button variant="outline-secondary" onClick={onClear} title="Clear filters">
            <i className="bi bi-x-circle" />
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default SchoolFilterBar;
